import { useMutation } from '@tanstack/react-query';
import { type PDFTemplateUrlRequest } from '../../contracts';
import { getUploadTemplateURL } from '../api/templates';

export const useGetUploadTemplateURL = () => {
  return useMutation({
    mutationFn: async (request: PDFTemplateUrlRequest) => {
      const { data } = await getUploadTemplateURL(request);
      return data;
    },
  });
};
